module.exports = __webpack_public_path__ + "img/home.572c1f75.svg";